import React from "react";
import Skeleton from "react-loading-skeleton";

const MembershipSkeleton: React.FC = () => {
    return (
        <div className="app-page p-0 bg-white membership-page">
            <div className="p-3 membership-content">
                <Skeleton height={150} width={'100%'} className="mb-3 membership-card" />
                <Skeleton height={150} width={'100%'} className="mb-3 membership-card" />
            </div>
        </div>
    )
}

export default MembershipSkeleton;